import styled from 'styled-components';
import { COLORS } from '../../../../utils/styles';

export const MainLogo = styled.img`
  height: 2rem;
  display: flex;
  padding-left: 0.5rem;
`;

export const Disclaimer = styled.p`
  font-family: 'SanFrancisco';
  font-size: 11px;
  color: ${COLORS.naturalGray};
`;



// WEBPACK FOOTER //
// ./src/views/officials-connect/layouts/AuthFlow/styled-components.js